import type { PopDevToolsRelayEvent } from 'common/models/ipc-messages';

import { isPopDevToolsEnabled } from '../enabled';
import { popDevTools } from '../pop-devtools';

type IpcReceiveRegistrar = (callback: (type: any, ...handlerArgs: any[]) => void | symbol) => () => void;

let unregisterRelayTap: (() => void) | undefined;

export const ingestMainRelayEvents = (events: readonly PopDevToolsRelayEvent[]) => {
  if (!isPopDevToolsEnabled()) return;

  events.forEach((event) => {
    popDevTools.record({
      ts: event.ts,
      source: 'main',
      channel: 'electron',
      level: event.level,
      message: event.message,
      data: event.data,
      isMarker:
        typeof event.data === 'object' &&
        event.data !== null &&
        typeof (event.data as { droppedEventCount?: unknown }).droppedEventCount === 'number',
    });
  });
};

export const installMainRelayTap = (registerIpcReceiveCallback: IpcReceiveRegistrar) => {
  if (unregisterRelayTap || !isPopDevToolsEnabled()) return;

  unregisterRelayTap = registerIpcReceiveCallback((type, events) => {
    if (type !== 'onPopDevToolsEvents' || !Array.isArray(events)) return;
    ingestMainRelayEvents(events);
  });
};

const uninstallMainRelayTapForTests = () => {
  unregisterRelayTap?.();
  unregisterRelayTap = undefined;
};
